jQuery( function ( $ ) {
    'use strict';

    let newsletter_signup_form_footer = jQuery( '#gform_1 .gform_footer' );

    newsletter_signup_form_footer.append(`
        <div class="newsletter-signup-disclaimer">
            By submitting this form, you are consenting to receive marketing emails from: 
            Belfast Area Chamber of Commerce, 14 Main Street, Belfast, ME, 04915, US, www.belfastmaine.org. 
            You can revoke your consent to receive emails at any time by using the SafeUnsubscribe® link, 
            found at the bottom of every email. 
            <a href="https://www.constantcontact.com/" target="_blank">Emails are serviced by Constant Contact.</a>
        </div>
    `);

    // here for each comment reply link of WordPress
    $( '.comment-reply-link' ).addClass( 'btn btn-primary' );

    // here for the submit button of the comment reply form
    $( '#commentsubmit' ).addClass( 'btn btn-primary' );

    let top_menu_items = jQuery( '#masthead .navbar-nav > li > a').not('#search-link');
    top_menu_items.each(function( index ) {
        jQuery(this).contents().unwrap().wrap('<span class="dropdown-toggle nav-link"></span>');
    } );

    pma_back_to_top_link();
    pma_handle_menu_click();

    // The WordPress Default Widgets
    // Now we'll add some classes for the WordPress default widgets - let's go

    // the search widget
    $( '.widget_search input.search-field' ).addClass( 'form-control' );
    $( '.widget_search input.search-submit' ).addClass( 'btn btn-default' );
    $( '.variations_form .variations .value > select' ).addClass( 'form-control' );
    $( '.widget_rss ul' ).addClass( 'media-list' );

    $( '.widget_meta ul, .widget_recent_entries ul, .widget_archive ul, .widget_categories ul, .widget_nav_menu ul, .widget_pages ul, .widget_product_categories ul' ).addClass( 'nav flex-column' );
    $( '.widget_meta ul li, .widget_recent_entries ul li, .widget_archive ul li, .widget_categories ul li, .widget_nav_menu ul li, .widget_pages ul li, .widget_product_categories ul li' ).addClass( 'nav-item' );
    $( '.widget_meta ul li a, .widget_recent_entries ul li a, .widget_archive ul li a, .widget_categories ul li a, .widget_nav_menu ul li a, .widget_pages ul li a, .widget_product_categories ul li a' ).addClass( 'nav-link' );

    // Adding Class to Woocommerce form
    $('.woocommerce-Input--text, .woocommerce-Input--email, .woocommerce-Input--password').addClass('form-control');
    $('.woocommerce-Button.button').addClass('btn btn-primary mt-2').removeClass('button');

    // Allow smooth scroll
    $('.page-scroller').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').animate({
            'scrollTop': $target.offset().top
        }, 1000, 'swing');
    });

    DFLIP.defaults.onFlip = function(flipbook){
        flipbook.getURLHash();
    }

});
function pma_handle_menu_click() {
    let dropdown_toggle_button = jQuery('button.navbar-toggler');
    let dropdown_toggle = jQuery('.dropdown-toggle, .dropdown-item');
    dropdown_toggle.on('click', function(event) {
        // If the mobile menu toggle is not visible, that means we are on a non-mobile version of the site.
        if( ! dropdown_toggle_button.is(":visible")) {
            return true;
        }
        if( ! jQuery(this).hasClass('expanded') ) {
            event.preventDefault();
            jQuery(this).addClass('expanded');
        }
    });
}

function pma_back_to_top_link() {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn();
        } else {
            jQuery('#back-to-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    jQuery('#back-to-top').on('click touchstart', function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
}